import { render, staticRenderFns } from "./OrderSingleCustomer.vue?vue&type=template&id=3bb45cb4&"
import script from "./OrderSingleCustomer.vue?vue&type=script&lang=js&"
export * from "./OrderSingleCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports